<template>
  <el-dialog
    :visible.sync="value.visible"
    title="标签"
    width="700px"
    :destroy-on-close="true"
    append-to-body
    @open="onDlgOpen"
    @closed="onDlgClosed"
  >
    <div>
      <div v-loading="$store.state.app.loadingList.includes('changeTagObj')">
        <div class="my-3">已添加标签</div>
        <div v-if="itemTagList.length > 0">
          <el-tag
            v-for="(item, index) in itemTagList"
            :key="index"
            class="mx-1 my-1"
            closable
            :disable-transitions="false"
            type="info"
            @close="onCloseTag(item, index)"
          >
            {{ item.tag.tag }}
          </el-tag>
        </div>

        <div v-if="itemTagList.length <= 0" class="has-text-light mx-1">无</div>

      </div>
      <el-divider />
      <div v-loading="$store.state.app.loadingList.includes('listTag-DlgSetTag')">
        <div class="my-3">点选添加标签</div>
        <div v-if="tagList.length > 0">
          <el-tag
            v-for="item in tagList"
            :key="item.id.toString()"
            class="mx-1 my-1 cursor-hand"
            type="info"
            @click="onAddOldTag(item)"
          >
            {{ item.tag }}
          </el-tag>
        </div>
        <div v-if="tagList.length <= 0" class="has-text-light">还没创建标签</div>
      </div>
    </div>
    <div class="my-3">
      <div class="has-text-primary cursor-hand" @click="onTagManage">创建 / 管理标签</div>
    </div>

    <template #footer>
      <!-- <span class="dialog-footer">
        <el-button @click="onCancel">取消</el-button>
        <el-button type="primary" @click="onOk">保存</el-button>
      </span> -->
    </template>

    <!-- 对话框 -->
    <DlgTagManagement
      v-model="dlgTagManagement.val"
      :org-id="dlgTagManagement.orgId"
      :tag-type="dlgTagManagement.tagType"
      @closed="onDlgTagManagementClosed"
    />

  </el-dialog>
</template>

<script>
import { listTag, listTagObj, delTagObj, createTagObj } from '@/api/util'
import DlgTagManagement from '@/components/DlgTagManagement.vue'

export default {
  name: 'DlgSetTag',
  components: {
    DlgTagManagement
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        visible: false,
        item: null
      })
    },
    params: {
      type: Object,
      default: () => ({
        orgId: '',
        formId: '',
        tagType: 0
      })
    }
  },
  emits: ['ok', 'cancel'],
  data() {
    return {
      itemTagList: [],
      tagList: [],

      dlgTagManagement: {
        val: {
          visible: false
        },
        orgId: '',
        tagType: 0
      }
    }
  },
  computed: {
  },
  watch: {

  },
  created() {
  },
  async mounted() {
    console.log(this.value)
    console.log(this.params)
  },

  methods: {
    async listTag() {
      this.tagList = []
      this.tagList = await listTag({
        query: `?org_id=${this.params.orgId}&form_id=${this.params.formId}&tag_type=${this.params.tagType}`
      }, 'listTag-DlgSetTag')
    },

    async listTagObj() {
      this.itemTagList = []
      this.itemTagList = await listTagObj({
        query: `?obj_id=${this.value.item.id}&expand=tag`
      }, 'changeTagObj')
    },

    async onDlgOpen() {
      this.listTagObj()
      this.listTag()
    },

    async onCloseTag(tag, index) {
      const res = await delTagObj({
        id: tag.id
      }, 'changeTagObj')
      console.log(res)
      this.itemTagList.splice(index, 1)
    },

    onClickTag(tag, index) {
      console.log(index)
      console.log(tag)
    },

    async onAddOldTag(tag) {
      const that = this
      const index = that.itemTagList.findIndex((i) => i.tag_id === tag.id)
      if (index === -1) {
        const res = await createTagObj({
          tag_id: tag.id,
          obj_id: that.value.item.id
        }, 'changeTagObj')
        console.log(res)
        that.itemTagList.push({
          id: res,
          tag_id: tag.id,
          obj_id: that.value.item.id,
          tag: tag
        })
      }
    },

    onTagManage() {
      // this.value.visible = false
      // this.$emit('manage')
      this.dlgTagManagement.orgId = this.params.orgId
      this.dlgTagManagement.tagType = this.params.tagType
      this.dlgTagManagement.val.visible = true
    },

    onDlgTagManagementClosed(isChanged) {
      if (isChanged) {
        this.listTag()
        this.$emit('manage', true)
      }
    },

    onCancel() {
      console.log('cancel')
      this.$emit('cancel')
      this.value.visible = false
    },
    async onOk() {
      console.log('ok')
      this.$message({
        message: '操作成功',
        type: 'success'
      })
      this.$emit('ok', this.value)
      this.value.visible = false
    },
    onDlgClosed() {
      // this.value.item.tags = this.itemTagList
      // this.$forceUpdate()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

</style>
